// extracted by mini-css-extract-plugin
export default {"mapbox":"Mapbox_mapbox__8P9z"};